/**
 * Rebuy Progress Bar Gift Cleaner
 * Includes extensive toggleable logging for troubleshooting
 */
(function () {
  const DEBUG = false;

  // Logging helpers
  function log(...args) {
    if (DEBUG) console.log('🎁 Rebuy Gift Cleaner:', ...args);
  }

  function logError(...args) {
    if (DEBUG) console.error('🎁 Rebuy Gift Cleaner ERROR:', ...args);
  }

  // Hide gifts with Re-add buttons
  function cleanUpRemovedGiftUI() {
    log('Running cleanup function');

    try {
      const allGiftInfos = document.querySelectorAll('.rebuy-cart__progress-gift-info');
      log(`Found ${allGiftInfos.length} gift info elements`);

      let hiddenCount = 0;

      allGiftInfos.forEach((giftInfo, index) => {
        log(`Examining gift info #${index}:`, giftInfo);

        const reAddBtn = giftInfo.querySelector('.rebuy-cart__progress-gift-variant-readd');
        if (reAddBtn) {
          log(`Gift #${index} has a Re-add button`, reAddBtn);

          // Hide gift info
          log(`Hiding gift info #${index}`);
          giftInfo.style.display = 'none';

          // Fully remove the image from DOM
          const imageEl = giftInfo
            .closest('.rebuy-cart__progress-gift')
            ?.querySelector('.rebuy-cart__progress-gift-image');
          if (imageEl) {
            log(`Removing image for gift #${index}:`, imageEl);
            imageEl.remove();
          } else {
            log(`No image found for gift #${index}`);
          }

          // Hide the associated progress bar prompt (if still visible)
          const progressPrompt = document.getElementById('rebuy-cart__progress-bar-meter-label');
          if (progressPrompt) {
            log(`Found progress prompt: "${progressPrompt.textContent}"`);
            if (progressPrompt.textContent.includes('REGALO:')) {
              log('Hiding progress prompt with REGALO text');
              progressPrompt.style.display = 'none';
            }
          } else {
            log('No progress prompt found with ID rebuy-cart__progress-bar-meter-label');
          }

          hiddenCount++;
        } else {
          log(`Gift #${index} does NOT have a Re-add button`);
        }
      });

      log(`Cleanup complete. Hidden ${hiddenCount} out of ${allGiftInfos.length} gifts`);
    } catch (error) {
      logError('Error during cleanup', error);
    }
  }

  // Run on gift removal click
  log('Setting up click event listener');
  document.addEventListener('click', e => {
    const clickedBtn = e.target.closest('.rebuy-cart__progress-gift-remove');
    if (clickedBtn) {
      log('Gift remove button clicked', clickedBtn);
      log('Scheduling cleanup in 500ms');
      setTimeout(() => {
        log('Running scheduled cleanup after button click');
        cleanUpRemovedGiftUI();
      }, 500);
    }
  });
  // Check if Rebuy is available
  log('Checking for Rebuy SmartCart');
  if (window.Rebuy) {
    log('Rebuy found:', window.Rebuy);
    if (window.Rebuy.SmartCart) {
      log('SmartCart found:', window.Rebuy.SmartCart);
      if (typeof window.Rebuy.SmartCart.addListener === 'function') {
        log('addListener method available, setting up SmartCart event listeners');

        // Run when cart is opened
        window.Rebuy.SmartCart.addListener('Show', () => {
          log('SmartCart Show event triggered');

          // Add immediate visual hiding to prevent flicker
          document.querySelectorAll('.rebuy-cart__progress-gift-info').forEach(giftInfo => {
            const reAddBtn = giftInfo.querySelector('.rebuy-cart__progress-gift-variant-readd');
            if (reAddBtn) {
              // Immediately hide parent to prevent flicker
              const giftBlock = giftInfo.closest('.rebuy-cart__progress-gift');
              if (giftBlock) {
                giftBlock.style.opacity = '0';
              }
            }
          });

          // Then do full cleanup very quickly
          log('Scheduling immediate cleanup');
          setTimeout(() => {
            log('Running scheduled cleanup after Show event');
            cleanUpRemovedGiftUI();
          }, 10);
        });
      } else {
        log('WARNING: addListener method not found on SmartCart');
        log('SmartCart methods:', Object.keys(window.Rebuy.SmartCart));
      }
    } else {
      log('WARNING: SmartCart not found on Rebuy object');
    }
  } else {
    log('WARNING: Rebuy not found in window');
  }
  // Run on page load
  log('Setting up DOMContentLoaded event');
  document.addEventListener('DOMContentLoaded', () => {
    log('DOMContentLoaded event triggered');
    log('Scheduling cleanup in 500ms');
    setTimeout(() => {
      log('Running scheduled cleanup after DOMContentLoaded');
      cleanUpRemovedGiftUI();
    }, 500);
  });

  // Also run now if page is already loaded
  log('Checking document.readyState:', document.readyState);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    log('Page already loaded, scheduling immediate cleanup');
    setTimeout(() => {
      log('Running scheduled immediate cleanup');
      cleanUpRemovedGiftUI();
    }, 500);
  }

  // Add an extra timed check to catch any late-loading elements
  log('Setting up final delayed check');
  setTimeout(() => {
    log('Running final delayed check');
    cleanUpRemovedGiftUI();
  }, 2000);

  log('Script initialization complete');
})();
